import { Component, EventEmitter, forwardRef, Inject, Input, Output } from '@angular/core';

import { VgStates } from './videogular/VgStates';
import { VideogularComponent } from './videogular/Videogular.Component';

import { VbOverlayBufferingManagerComponent } from './VbOverlayBufferingManager.Component';
import { VbStartAtManagerComponent } from './VbStartAtManager.Component';

import { VBRICK_PLAYER_HOST } from './VbPlayerHostToken';

const PLAY_SURFACING_WIGGLE_ROOM_MS: number = 1000;

@Component({
	selector: 'vb-overlay-play-controls',
	template: `
		@if (manageOverlayControlsDisplay(); as overlay) {
			<div [hidden]="overlay.hideWrapper" class="root"
				(click)="onPlayClick()"
  				(keydown.enter)="onPlayClick()"
  				tabindex="0"
  				role="button">
				<div
					[ngClass]="[
						'container',
						isSmallSizePlayer ? 'smallSizeOverlay' : ''
					]"
				>
					@if (!vbrickPlayer.isLive && vbrickPlayer.playerControls.overlaySeekControls) {
						<vg-seek
							[hidden]="overlay.hideControl || !isInitialPlayNotAtStart"
							[translations]="vbrickPlayer.translations"
							[isBackward]="true"
							[disableControlBarFocus]="true">
						</vg-seek>
					}
					<div class="playIconWrapper">
						<button
							type="button"
							class="button vb-icon vb-icon-play-rounded"
							[attr.aria-label]="vbrickPlayer.translations.play"
							[hidden]="overlay.hideControl">
						</button>
					</div>
					@if (!vbrickPlayer.isLive && vbrickPlayer.playerControls.overlaySeekControls) {
						<vg-seek
							[hidden]="overlay.hideControl || !isInitialPlayNotAtStart"
							[translations]="vbrickPlayer.translations"
							[disableControlBarFocus]="true">
						</vg-seek>
					}
				</div>
			</div>
		}
	`,
	standalone: false,
	styleUrls: ['./VbOverlayPlayControls.Component.ng.less']
})
export class VbOverlayPlayControlsComponent {
	@Input() public vbStartAtManager: VbStartAtManagerComponent;
	@Input() public overlayBufferingManager: VbOverlayBufferingManagerComponent = {} as any;
	@Input() public isInitialPlay: boolean;
	@Input() public isInitialPlayNotAtStart: boolean;
	@Input() public isSmallSizePlayer: boolean;

	@Output() public overlayControlsDisplayChanged = new EventEmitter<boolean>();

	constructor(
		@Inject(VBRICK_PLAYER_HOST)
		public vbrickPlayer: any,
		private vgApi: VideogularComponent
	) {}

	private overlayHiddenCopy;

	public manageOverlayControlsDisplay(): any {
		const overlayHidden = this.isOverlayWrraperHidden();

		this.emitDisplayChangedEvent(overlayHidden);

		return {
			hideWrapper: overlayHidden,
			hideControl: !this.isControlDisplay
		};
	}

	public get isControlDisplay(): boolean {
		return this.vbrickPlayer.playerControls.overlayControls &&
			(
				this.vbrickPlayer.isLive ||
				this.isInitialPlay ||
				this.vbrickPlayer.playerControls.overlayPlayControlOnStop ||
				this.vbStartAtManager.isNoResumeActive
			);
	}

	public onPlayClick(): void {
		this.vgApi.play();
	}

	private isOverlayWrraperHidden(): boolean {
		return !this.vgApi.analyticsEnabled ||
			this.vgApi.isBufferingOverride ||
			this.overlayBufferingManager.isBuffering ||
			this.vgApi.isPlaybackPluginLoading ||
			this.vgApi.currentState === VgStates.PLAY ||
			!this.vgApi.isSupportedPlaybackOptions ||
			(this.vbrickPlayer.isLive && this.vgApi.currentState === VgStates.PAUSE) ||
			(this.vgApi.activeSource && this.vgApi.activeSource.isUnavailable);
	}

	private emitDisplayChangedEvent(overlayHidden: boolean): void {
		if (!this.vbrickPlayer.playerControls.overlayPlayControlOnStop
			|| overlayHidden === this.overlayHiddenCopy) {
			return;
		}
		this.overlayHiddenCopy = overlayHidden;
		this.overlayControlsDisplayChanged.emit(!overlayHidden);

	}
}
